import { useQuery } from '@tanstack/react-query';
import { getAutodeskIntegrationViewerDetails } from 'api/services';

const useAutodeskIntegrationViewerData = (token: string) => {
    const autodeskIntegrationViewerQuery = useQuery(
        ['autodeskIntegrationViewer', token],
        () => getAutodeskIntegrationViewerDetails(token),
        { enabled: Boolean(token) }
    );

    return {
        isLoading: autodeskIntegrationViewerQuery.isLoading,
        error: autodeskIntegrationViewerQuery.error,
        camera: autodeskIntegrationViewerQuery.data?.camera,
        project: autodeskIntegrationViewerQuery.data?.project,
        integration: autodeskIntegrationViewerQuery.data?.integration,
    };
};

export default useAutodeskIntegrationViewerData;
